/*
 * Keeps the cart page and the header cart drawer in step with Discount Ninja.
 *
 * Discount Ninja can apply its discount after the cart markup was rendered
 * (on page load, or after a quantity change), so the Liquid totals go stale.
 * Both cart-content.liquid and header-cart.liquid print the totals they were
 * rendered with into a [data-cart-rendered-total] marker; after any cart
 * write, or any cart read by Discount Ninja, we compare that marker with the
 * live cart and re-render whichever view is out of date.
 */
(function () {
  if (!('PerformanceObserver' in window)) return;

  // A cart write is usually followed by the theme re-rendering the cart
  // itself, so wait long enough for that render to land before comparing.
  // Once the theme's render (cart?view=json / cart?view=jsonpage) or Discount
  // Ninja's own cart read has completed, the markup is settled: check soon.
  // Discount Ninja also polls a productData GraphQL query every few hundred
  // ms; matching that would keep resetting the debounce, so it is left out.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var CART_RENDER = /\/cart\?view=json(page)?(&|$)/i;
  var DN_CART_READ = /[?&]app=discountninja/i;
  var WRITE_DELAY = 800;
  var SETTLED_DELAY = 250;
  var timer = null;

  // Our own re-render also counts as "settled" and triggers one more check.
  // Cap the re-renders per cart write so a total that never matches (say,
  // another app rewriting prices) cannot keep the cart refreshing.
  var MAX_RESYNCS_PER_WRITE = 2;
  var resyncs = 0;
  // Set while a re-render we asked for is in flight; its markers are not in
  // the DOM yet, so checking now would only ask for the same render again.
  var rendering = false;

  function isStale(marker, cart) {
    return (
      String(cart.total_price) !== marker.dataset.cartRenderedTotal ||
      String(cart.item_count) !== marker.dataset.cartRenderedCount
    );
  }

  function resync() {
    // $360 is a top-level const in vendor.js, so it is not on window
    if (typeof $360 === 'undefined') return;
    if (rendering || resyncs >= MAX_RESYNCS_PER_WRITE) return;

    var pageMarker = document.querySelector('#cart-content [data-cart-rendered-total]');
    var drawer = document.getElementById('header-cart');
    var drawerMarker = drawer && drawer.querySelector('[data-cart-rendered-total]');
    if (!pageMarker && !drawerMarker) return;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var pageStale = pageMarker && isStale(pageMarker, cart);
        var drawerStale = drawerMarker && isStale(drawerMarker, cart);
        if (pageStale || drawerStale) resyncs++;

        if (pageStale) {
          rendering = true;
          $360.refreshCartPage();
        }

        if (drawerStale) {
          if (drawer.classList.contains('active')) {
            rendering = true;
            $360.showHeaderCart({ update: true });
          } else {
            // Closed drawer: drop the stale markup. showHeaderCart() fetches
            // fresh markup whenever #header-cart is empty, as on first load.
            drawer.innerHTML = '';
          }
        }
      })
      .catch(function (e) {
        console.log(e);
      });
  }

  new PerformanceObserver(function (list) {
    var entries = list.getEntries();
    function seen(pattern) {
      return entries.some(function (entry) {
        return pattern.test(entry.name);
      });
    }
    var written = seen(CART_WRITE);
    var rendered = seen(CART_RENDER);
    var settled = rendered || seen(DN_CART_READ);
    if (!settled && !written) return;

    if (written) resyncs = 0;
    // A finished render, or a new write, means nothing of ours is pending
    if (rendered || written) rendering = false;
    clearTimeout(timer);
    timer = setTimeout(resync, settled ? SETTLED_DELAY : WRITE_DELAY);
  }).observe({ type: 'resource', buffered: true });
})();
